import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';

import { type RelatedNewsNormalized } from 'hb-react/shared/apps/News/types';
import {
  Grid,
  Col,
  Row,
  getBpNum,
} from 'hb-react/shared/components/DesignSystem/Grid';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import NewsRelatedRow from './components/NewsRelatedRow';

interface NewsRelatedProps {
  relatedNews: Array<RelatedNewsNormalized>;
}

const NewsRelated = ({ relatedNews }: NewsRelatedProps) => {
  const outboxedFontTheme = useOutboxedFontTheme();

  if (relatedNews.length === 0) {
    return null;
  }

  return (
    <Container pb={15} height="auto">
      <Grid width="100%" height="100%">
        <Row>
          <Col
            width={({ numCols }) => ({
              xl: 4 / getBpNum(numCols, 'xl'),
              m: 5 / getBpNum(numCols, 'm'),
            })}
            offset={({ numCols }) => ({
              xl: 2 / getBpNum(numCols, 'xl'),
              m: 1 / getBpNum(numCols, 'm'),
            })}
          >
            <ThemeProvider
              theme={outboxedFontTheme.themeName}
              fontBrightness={outboxedFontTheme.fontBrightness}
            >
              <Box font="h2-semibold" fontWeight="600" lineHeight="29px" mt={9}>
                {s__('News|Other news')}
              </Box>
            </ThemeProvider>
          </Col>
        </Row>
        <NewsRelatedRow relatedNews={relatedNews} />
      </Grid>
    </Container>
  );
};

export default NewsRelated;
